import { Controller } from "stimulus";

export default class extends Controller {
  redirectToParamPath(event) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(this.element.dataset.param, event.target.value);
    window.location.search = urlParams;
  }
}
